import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import JBImage from 'components/essentials/JBImage';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';
import Link from 'components/consumer/Link';
import useScreen from 'hooks/useScreen';
import NukaCarousel from 'components/external/NukaCarousel';
const PDPCollectionSliderUI = t0 => {
  const $ = _c(28);
  const {
    loading,
    productImgs: t1,
    collectionSlug,
    collectionLink: t2
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const productImgs = t3;
  const collectionLink = t2 === undefined ? "" : t2;
  const {
    isMobileOrTablet
  } = useScreen();
  const [showControls, setShowControls] = useState(false);
  let t4;
  let t5;
  if ($[2] !== isMobileOrTablet) {
    t4 = () => {
      if (isMobileOrTablet) {
        setShowControls(true);
      }
    };
    t5 = [isMobileOrTablet];
    $[2] = isMobileOrTablet;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  if (!productImgs?.length) {
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="PDPCollectionSliderUI__filler" />;
      $[5] = t6;
    } else {
      t6 = $[5];
    }
    return t6;
  }
  if (loading) {
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="PDPCollectionSliderUI--loader">Loading...</div>;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    return t6;
  }
  let t6;
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setShowControls(true);
    };
    t7 = () => {
      setShowControls(false);
    };
    $[7] = t6;
    $[8] = t7;
  } else {
    t6 = $[7];
    t7 = $[8];
  }
  const t8 = `/${collectionLink}`;
  const t9 = `More from the ${collectionSlug || ""}`;
  let t10;
  if ($[9] !== t9) {
    t10 = <div className="text-lg font-bold text-brand mb-2">{t9}</div>;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t8) {
    t11 = <Link to={t8} className="no-underline">{t10}</Link>;
    $[11] = t10;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = isMobileOrTablet ? 2 : 3;
  let t13;
  let t14;
  if ($[14] !== productImgs.length || $[15] !== showControls) {
    t13 = t15 => {
      const {
        previousSlide
      } = t15;
      if (productImgs.length < 3) {
        return null;
      }
      return <button type="button" className={cx("!bg-transparent !border-0 w-[30px] h-[30px] cursor-pointer transition-[all_.2s_ease-in] [&_svg]:max-[1023px]:w-2.5 btn !bg-white left-2 transform-[translateX(-50%)]", {
        "opacity-0": !showControls,
        "opacity-100": showControls
      })} aria-label="Previous slide" onClick={previousSlide}>{" "}<IconArrowLeftWhite /></button>;
    };
    t14 = t16 => {
      const {
        nextSlide
      } = t16;
      if (productImgs.length < 3) {
        return null;
      }
      return <button type="button" className={cx("!bg-transparent !border-0 w-[30px] h-[30px] cursor-pointer transition-[all_.2s_ease-in] [&_svg]:max-[1023px]:w-2.5 btn !bg-white right-2 transform-[translateX(50%)]", {
        "opacity-0": !showControls,
        "opacity-100": showControls
      })} aria-label="Next slide" onClick={nextSlide}><IconArrowRightWhite /></button>;
    };
    $[14] = productImgs.length;
    $[15] = showControls;
    $[16] = t13;
    $[17] = t14;
  } else {
    t13 = $[16];
    t14 = $[17];
  }
  let t15;
  if ($[18] !== productImgs) {
    t15 = productImgs.map(_temp2);
    $[18] = productImgs;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
    t16 = <NukaCarousel slidesToShow={t12} cellSpacing={0} className="m-0 px-[.7rem] py-0 [&_.slider-slide]:!flex [&_.slider-slide]:items-center" dragging={true} width="100%" initialSlideHeight={300} renderCenterLeftControls={t13} renderCenterRightControls={t14} renderBottomCenterControls={_temp}>{t15}</NukaCarousel>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t11 || $[26] !== t16) {
    t17 = <div className="w-full mt-6" onMouseOver={t6} onMouseOut={t7}>{t11}{t16}</div>;
    $[25] = t11;
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  return t17;
};
PDPCollectionSliderUI.propTypes = {
  loading: PropTypes.bool,
  productImgs: PropTypes.array,
  collectionSlug: PropTypes.string,
  collectionLink: PropTypes.string
};
export default PDPCollectionSliderUI;
function _temp() {
  return null;
}
function _temp2(prodImg) {
  return <div className="min-h-[110px] p-5 flex flex-col items-center justify-center" key={prodImg.url}><Link to={prodImg.url}><JBImage src={prodImg.src} width="200" height="200" fit="clip" trim="color" /></Link></div>;
}